import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IPromoVideoPayload {
  lang: string;
}

export const promoVideoSlice = createApi({
  reducerPath: 'promoVideo',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getPromoVideo'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['PromoVideo'],
  endpoints: (builder) => ({
    getPromoVideo: builder.query<IAnyResponse, IPromoVideoPayload>({
      query: (payload) => ({
        url: `/promo-video`,
        method: 'GET'
      })
    })
  })
});

export const { useGetPromoVideoQuery } = promoVideoSlice;
